import Vue from 'vue'
const app = new Vue();

//const port = window.location.hostname !== 'ivr.lapi.mx' ? '6001' : '6003';
const port = window.location.hostname !== 'ivr.lapi.mx' ? '6001' : '6002';

export default {
    socketHeaders() {
        return {
            host: `${window.location.hostname}:${port}`,
            //host: 'https://7af30ac7.ngrok.io',
            broadcaster: 'socket.io',
            auth: {
                headers: {
                    'Authorization': `Bearer ${app.$auth.token()}`
                }
            }
        }
    }
}
